import React from 'react';
import { Collapse } from 'react-collapse';
import noteTabBarEnhancer from "../../../../enhancers/noteTabBarEnhancer";
import addingNoteEnhancer from "../../../../enhancers/addingNoteEnhancer";
import NewNote, { NewPrivateNote } from "../../../../components/Notes/NewNote";
import AddHideNote from "./AddHideNote";
import { useInitialProps } from "../../../../hooks/useInitialProps";
import { useEventTracker } from '@applyboard/ui-utils';
import { _NoteTabBarWrapper, _NoteTabTopBar, _NoteTabExtensions } from "./styles";
var NoteTabBar = function NoteTabBar(_ref) {
  var addingNote = _ref.addingNote,
    addingPrivateNote = _ref.addingPrivateNote,
    onCollapseNote = _ref.onCollapseNote,
    onCollapsePrivateNote = _ref.onCollapsePrivateNote,
    privateOnly = _ref.privateOnly,
    publicOnly = _ref.publicOnly,
    userPermissions = _ref.userPermissions,
    _onAddNote = _ref.onAddNote,
    count = _ref.count,
    loading = _ref.loading,
    canCreateBulkNote = _ref.canCreateBulkNote,
    isMarkdownRendererEnabled = _ref.isMarkdownRendererEnabled;
  var isAddingNote = privateOnly ? addingPrivateNote : addingNote;
  var collapseNote = privateOnly ? onCollapsePrivateNote : onCollapseNote;
  var _useInitialProps = useInitialProps(),
    application = _useInitialProps.application;
  var _useEventTracker = useEventTracker({
      data: {
        applicationStage: application === null || application === void 0 ? void 0 : application.current_stage
      }
    }),
    trackEvent = _useEventTracker.trackEvent;
  React.useEffect(function () {
    if (!loading && count === 0) {
      _onAddNote(privateOnly ? 'private' : 'public');
    }
  });
  React.useEffect(function () {
    if (count === 1) {
      collapseNote();
    }
  }, [count]);
  return /*#__PURE__*/React.createElement(_NoteTabBarWrapper, {
    "walkme-id": "applications-notes"
  }, /*#__PURE__*/React.createElement(_NoteTabTopBar, null, privateOnly && (userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.create_private_note) && /*#__PURE__*/React.createElement(AddHideNote, {
    addingNote: isAddingNote,
    onCollapseNote: collapseNote,
    onAddNote: function onAddNote(e) {
      if (e) e.stopPropagation();
      trackEvent({
        event: "Single Application - Admin Comments - Clicked Add Note"
      });
      _onAddNote('private');
    }
  }), publicOnly && (userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.create_public_note) && /*#__PURE__*/React.createElement(AddHideNote, {
    addingNote: isAddingNote,
    onCollapseNote: collapseNote,
    onAddNote: function onAddNote(e) {
      if (e) e.stopPropagation();
      trackEvent({
        event: "Single Application - Notes - Clicked Add Note"
      });
      _onAddNote('public');
    }
  })), /*#__PURE__*/React.createElement(Collapse, {
    isOpened: isAddingNote
  }, /*#__PURE__*/React.createElement(_NoteTabExtensions, null, isAddingNote && (privateOnly ? /*#__PURE__*/React.createElement(NewPrivateNote, {
    canCreateBulkNote: canCreateBulkNote,
    isMarkdownRendererEnabled: isMarkdownRendererEnabled
  }) : /*#__PURE__*/React.createElement(NewNote, {
    canCreateBulkNote: canCreateBulkNote,
    isMarkdownRendererEnabled: isMarkdownRendererEnabled
  })))));
};
export default noteTabBarEnhancer(addingNoteEnhancer(NoteTabBar));